var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLowerX(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 33,
    viewBox: "0 0 29 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7543 1.78425L27.0958 0.222656L28.4511 1.09214L27.1096 2.65374L25.7543 1.78425ZM0.15332 1.11047L1.49498 0.225321L2.86071 1.77119L1.51905 2.65634L0.15332 1.11047ZM9.71631 11.9351L11.0582 11.0501L13.789 14.1423L12.4471 15.0272L9.71631 11.9351ZM16.5275 17.2461L15.1857 18.1311L17.9165 21.2232L19.2583 20.3383L16.5275 17.2461ZM4.24463 5.74287L5.58647 4.85793L8.3173 7.95008L6.97546 8.83503L4.24463 5.74287ZM21.9871 23.4284L20.6453 24.3133L23.3761 27.4055L24.7179 26.5205L21.9871 23.4284ZM26.1256 30.4637L27.4669 29.5782L28.8333 31.1237L27.492 32.0092L26.1256 30.4637ZM1.86415 29.6016L0.522583 31.1632L1.87789 32.0327L3.21946 30.4711L1.86415 29.6016ZM4.5271 26.5132L7.1834 23.4212L8.53871 24.2907L5.88241 27.3827L4.5271 26.5132ZM17.798 11.0558L15.1417 14.1478L16.497 15.0173L19.1533 11.9253L17.798 11.0558ZM9.83606 20.3276L12.4924 17.2357L13.8477 18.1052L11.1914 21.1971L9.83606 20.3276ZM23.0993 4.87786L20.443 7.96981L21.7983 8.8393L24.4546 5.74735L23.0993 4.87786Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowerX);
export default __webpack_public_path__ + "static/media/LOWER_X.854c6579de1bf3687dd1319891103a60.svg";
export { ForwardRef as ReactComponent };